export default "__VITE_ASSET__CXYc$dYV__"